<template>
  <div id="page-facility-details">
    <div class="mb-4">
      <h1>Facility: {{ model.FacilityReference }}</h1>
    </div>
    <facility-form
        v-if="model"
        ref="form"
        v-model="model"
        :loading="loading"
        card-title="Edit"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'facilities.view', params: { id } })"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '../../../components/mixins/SaveModelMixin';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import FacilityForm from '@/views/pages/facilities/FacilityForm';
import PageTitle from "@/views/components/extra-components/layout/PageTitle";
import CardPage from '../../components/Views/CardPage';

export default {
  name: 'FacilityEdit',
  components: {
    FacilityForm,
    PageTitle,
    CardPage,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities,
    };
  },
  methods: {
    getParams() {
      const params = this.setModelCopy({
        ...this.model
      });

      const references = [
        'ClassOfBusiness_FK',
        'FacilityType_FK',
        'CompanyLeadInsurer_FK',
        'TerritoryRiskLocation_FK',
        'TerritoryInsuredDomicile_FK',
        'TerritoryTerritorialLimit_FK',
        'CompanyLossAdjuster_FK',
      ];

      const multiReferences = [
        {
          array: 'managers',
          key: 'CompanyFacilityManager_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ]
        },
        {
          array: 'coverholders',
          key: 'CompanyCoverholder_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ],
        },
        {
          array: 'placing_brokers',
          key: 'CompanyPlacingBroker_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ],
        },
        {
          array: 'intermediary',
          key: 'CompanyIntermediary_FK',
          dates: [
            'InceptionDate',
            'ExpiryDate',
          ]
        },
      ];

      const dates = [
        'InceptionDate',
        'ExpiryDate',
        'ProfitCommissionDate',
        'BARefDate',
      ];

      this.setDates(dates, params);
      this.setMultiReferences(multiReferences, params);
      this.setReferences(references, params);

      return params;
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    validate() {
      return this.$refs.form.validate();
    },
    async save() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      try {
        const {data} = await this.$api.facilities.update(this.id, params);
        this.notifySuccess('Facility updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('Facility failed to be updated');
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
